import { all, takeLatest } from 'redux-saga/effects'
import store from '../../store'
import { actions } from './BarePallets.slice'
import { paginate } from './BarePallets.thunk'

function paginateBarePallets () {
  store.dispatch(paginate() as any)
}

export default function * effects () {
  yield all([
    takeLatest(actions.replaceLimit, paginateBarePallets),
    takeLatest(actions.replacePage, paginateBarePallets),
    takeLatest(actions.replaceSearch, paginateBarePallets),
    takeLatest(actions.replaceFilter, paginateBarePallets)
  ])
}
